module.exports = __webpack_public_path__ + "img/jiaruwomen_back.c67c6a6b.png";